<template>
  <p style="color: #000000">{{ $t("loginLineLoading") }}</p>
</template>

<script>
export default {};
</script>

<style>
</style>